import React from 'react';
import {FormField} from "../../types/games";


interface FormFieldsProps {
    form: FormField[];
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    disableForm?: boolean;
}

const FormFields: React.FC<FormFieldsProps> = ({ form, handleInputChange, handleCheckboxChange, onKeyDown, disableForm= false }) => {
    if (!form || form.length === 0) {
        return null;
    }

    const formFields = form.map((field, i) => {
        let elem;

        if (field.type === 'text') {
            elem = (
                <div className="form-text mb-0" dangerouslySetInnerHTML={{ __html: field.label as string }} />
            );
        } else if (field.type === 'custom_checkbox') {
            elem = (
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={field.value === '1'}
                        name={field.name}
                        id={field.name}
                        required={field.required}
                        onChange={handleCheckboxChange}
                        disabled={disableForm}
                        readOnly={field.readonly}
                    />
                    <label className="form-check-label form-label" htmlFor={field.name}>
                        {field.label}
                    </label>
                </div>
            );
        } else {
            const fieldType = field.type.includes('email') ? 'email' : 'text';
            elem = (
                <>
                    <label className="form-label" htmlFor={field.name}>
                        {field.label}
                    </label>
                    <input
                        className="form-control"
                        type={fieldType}
                        id={field.name}
                        value={field.value as string || ''}
                        name={field.name}
                        required={field.required}
                        disabled={disableForm}
                        readOnly={field.readonly}
                        onKeyDown={onKeyDown}
                        onChange={handleInputChange}
                    />
                </>
            );
        }

        return (
            <div key={i} className="form-group">
                {elem}
            </div>
        );
    });

    return <>{formFields}</>;
};

export default FormFields;
